// ── PAÍSES (ISO 3166-1 alpha-2 + nome em pt-BR) ──────────────────────────────
// DADOS, não geração em runtime: o cliente precisa da lista no bundle para desenhar o <select>, e
// `Intl.DisplayNames` não existe igual em todo navegador. Gerado uma vez com o ICU do Node 22 e
// versionado. A BANDEIRA não é dado — sai do próprio código de duas letras (`flagOf`).
// @ts-check
export const COUNTRIES=[
  ["AD","Andorra"],["AE","Emirados Árabes Unidos"],["AF","Afeganistão"],["AG","Antígua e Barbuda"],
  ["AI","Anguila"],["AL","Albânia"],["AM","Armênia"],["AO","Angola"],
  ["AQ","Antártida"],["AR","Argentina"],["AS","Samoa Americana"],["AT","Áustria"],
  ["AU","Austrália"],["AW","Aruba"],["AX","Ilhas Aland"],["AZ","Azerbaijão"],
  ["BA","Bósnia e Herzegovina"],["BB","Barbados"],["BD","Bangladesh"],["BE","Bélgica"],
  ["BF","Burquina Faso"],["BG","Bulgária"],["BH","Barein"],["BI","Burundi"],
  ["BJ","Benin"],["BL","São Bartolomeu"],["BM","Bermudas"],["BN","Brunei"],
  ["BO","Bolívia"],["BQ","Países Baixos Caribenhos"],["BR","Brasil"],["BS","Bahamas"],
  ["BT","Butão"],["BV","Ilha Bouvet"],["BW","Botsuana"],["BY","Bielorrússia"],
  ["BZ","Belize"],["CA","Canadá"],["CC","Ilhas Cocos (Keeling)"],["CD","Congo - Kinshasa"],
  ["CF","República Centro-Africana"],["CG","República do Congo"],["CH","Suíça"],["CI","Costa do Marfim"],
  ["CK","Ilhas Cook"],["CL","Chile"],["CM","Camarões"],["CN","China"],
  ["CO","Colômbia"],["CR","Costa Rica"],["CU","Cuba"],["CV","Cabo Verde"],
  ["CW","Curaçao"],["CX","Ilha Christmas"],["CY","Chipre"],["CZ","Tchéquia"],
  ["DE","Alemanha"],["DJ","Djibuti"],["DK","Dinamarca"],["DM","Dominica"],
  ["DO","República Dominicana"],["DY","Benin"],["DZ","Argélia"],["EC","Equador"],
  ["EE","Estônia"],["EG","Egito"],["EH","Saara Ocidental"],["ER","Eritreia"],
  ["ES","Espanha"],["ET","Etiópia"],["FI","Finlândia"],["FJ","Fiji"],
  ["FK","Ilhas Malvinas"],["FM","Micronésia"],["FO","Ilhas Faroé"],["FR","França"],
  ["GA","Gabão"],["GB","Reino Unido"],["GD","Granada"],["GE","Geórgia"],
  ["GF","Guiana Francesa"],["GG","Guernsey"],["GH","Gana"],["GI","Gibraltar"],
  ["GL","Groenlândia"],["GM","Gâmbia"],["GN","Guiné"],["GP","Guadalupe"],
  ["GQ","Guiné Equatorial"],["GR","Grécia"],["GS","Ilhas Geórgia do Sul e Sandwich do Sul"],["GT","Guatemala"],
  ["GU","Guam"],["GW","Guiné-Bissau"],["GY","Guiana"],["HK","Hong Kong, RAE da China"],
  ["HM","Ilhas Heard e McDonald"],["HN","Honduras"],["HR","Croácia"],["HT","Haiti"],
  ["HU","Hungria"],["HV","Burquina Faso"],["ID","Indonésia"],["IE","Irlanda"],
  ["IL","Israel"],["IM","Ilha de Man"],["IN","Índia"],["IO","Território Britânico do Oceano Índico"],
  ["IQ","Iraque"],["IR","Irã"],["IS","Islândia"],["IT","Itália"],
  ["JE","Jersey"],["JM","Jamaica"],["JO","Jordânia"],["JP","Japão"],
  ["KE","Quênia"],["KG","Quirguistão"],["KH","Camboja"],["KI","Quiribati"],
  ["KM","Comores"],["KN","São Cristóvão e Névis"],["KP","Coreia do Norte"],["KR","Coreia do Sul"],
  ["KW","Kuwait"],["KY","Ilhas Cayman"],["KZ","Cazaquistão"],["LA","Laos"],
  ["LB","Líbano"],["LC","Santa Lúcia"],["LI","Liechtenstein"],["LK","Sri Lanka"],
  ["LR","Libéria"],["LS","Lesoto"],["LT","Lituânia"],["LU","Luxemburgo"],
  ["LV","Letônia"],["LY","Líbia"],["MA","Marrocos"],["MC","Mônaco"],
  ["MD","Moldávia"],["ME","Montenegro"],["MF","São Martinho"],["MG","Madagascar"],
  ["MH","Ilhas Marshall"],["MK","Macedônia do Norte"],["ML","Mali"],["MM","Mianmar (Birmânia)"],
  ["MN","Mongólia"],["MO","Macau, RAE da China"],["MP","Ilhas Marianas do Norte"],["MQ","Martinica"],
  ["MR","Mauritânia"],["MS","Montserrat"],["MT","Malta"],["MU","Maurício"],
  ["MV","Maldivas"],["MW","Malaui"],["MX","México"],["MY","Malásia"],
  ["MZ","Moçambique"],["NA","Namíbia"],["NC","Nova Caledônia"],["NE","Níger"],
  ["NF","Ilha Norfolk"],["NG","Nigéria"],["NH","Vanuatu"],["NI","Nicarágua"],
  ["NL","Países Baixos"],["NO","Noruega"],["NP","Nepal"],["NR","Nauru"],
  ["NU","Niue"],["NZ","Nova Zelândia"],["OM","Omã"],["PA","Panamá"],
  ["PE","Peru"],["PF","Polinésia Francesa"],["PG","Papua-Nova Guiné"],["PH","Filipinas"],
  ["PK","Paquistão"],["PL","Polônia"],["PM","São Pedro e Miquelão"],["PN","Ilhas Pitcairn"],
  ["PR","Porto Rico"],["PS","Territórios palestinos"],["PT","Portugal"],["PW","Palau"],
  ["PY","Paraguai"],["QA","Catar"],["RE","Reunião"],["RH","Zimbábue"],
  ["RO","Romênia"],["RS","Sérvia"],["RU","Rússia"],["RW","Ruanda"],
  ["SA","Arábia Saudita"],["SB","Ilhas Salomão"],["SC","Seicheles"],["SD","Sudão"],
  ["SE","Suécia"],["SG","Singapura"],["SI","Eslovênia"],["SJ","Svalbard e Jan Mayen"],
  ["SK","Eslováquia"],["SL","Serra Leoa"],["SM","San Marino"],["SN","Senegal"],
  ["SO","Somália"],["SR","Suriname"],["SS","Sudão do Sul"],["ST","São Tomé e Príncipe"],
  ["SV","El Salvador"],["SX","Sint Maarten"],["SY","Síria"],["SZ","Essuatíni"],
  ["TC","Ilhas Turcas e Caicos"],["TD","Chade"],["TF","Territórios Franceses do Sul"],["TG","Togo"],
  ["TH","Tailândia"],["TJ","Tadjiquistão"],["TK","Tokelau"],["TL","Timor-Leste"],
  ["TM","Turcomenistão"],["TN","Tunísia"],["TO","Tonga"],["TR","Turquia"],
  ["TT","Trinidad e Tobago"],["TV","Tuvalu"],["TW","Taiwan"],["TZ","Tanzânia"],
  ["UA","Ucrânia"],["UG","Uganda"],["UK","Reino Unido"],["UM","Ilhas Menores Distantes dos EUA"],
  ["US","Estados Unidos"],["UY","Uruguai"],["UZ","Uzbequistão"],["VA","Cidade do Vaticano"],
  ["VC","São Vicente e Granadinas"],["VD","Vietnã"],["VE","Venezuela"],["VG","Ilhas Virgens Britânicas"],
  ["VI","Ilhas Virgens Americanas"],["VN","Vietnã"],["VU","Vanuatu"],["WF","Wallis e Futuna"],
  ["WS","Samoa"],["XK","Kosovo"],["YE","Iêmen"],["YT","Mayotte"],
  ["ZA","África do Sul"],["ZM","Zâmbia"],["ZW","Zimbábue"]
];
export const COUNTRY_BY_CODE=new Map(COUNTRIES);
/** Topo do seletor: onde o jogo é jogado hoje. O resto vem em ordem alfabética embaixo. */
export const POPULAR=['BR','PT','US','AR','MX','CO','CL','ES','FR','DE','IT','GB','CA','JP'];
export const isCountry=c=>typeof c==='string'&&/^[A-Z]{2}$/.test(c)&&COUNTRY_BY_CODE.has(c);
/** Normaliza o que veio do cliente: 'br' → 'BR'; qualquer outra coisa → null (limpa o campo). */
export const cleanCountry=c=>{const s=String(c||'').trim().toUpperCase();return isCountry(s)?s:null;};
/** 'BR' → 🇧🇷 — o par de indicadores regionais é o próprio código deslocado para U+1F1E6. */
export const flagOf=c=>isCountry(c)?String.fromCodePoint(...[...c].map(ch=>127397+ch.charCodeAt(0))):'';
export const countryName=c=>COUNTRY_BY_CODE.get(c)||c||'';
